export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/demo/hotel-site/images/hero.png"
          alt="The Azalea Tokyo"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h2 className="text-5xl md:text-7xl font-serif text-white mb-4 tracking-wide">
          静謐なる至福
        </h2>
        <p className="text-xl md:text-2xl font-light text-white mb-8 tracking-wider">
          東京の頂で、特別な時を
        </p>
        <button className="mt-8 px-10 py-4 bg-white text-gray-900 text-sm tracking-widest whitespace-nowrap hover:bg-gray-100 transition-colors">
          ご予約
        </button>
      </div>
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <i className="ri-arrow-down-line text-white text-3xl animate-bounce"></i>
      </div>
    </section>
  );
}